


let seize_rest = seize_data.site_url + '/wp-json/tunnel/v1'
$('.ki-product__image__slider').slick({
  slidesToShow: 1,
  dots: false,
  arrows: false,
  infinite: true,
  fade: true,
})
$('.ki-product__image__slider_second').slick({
  slidesToShow: 1,
  dots: false,
  arrows: false,
  infinite: true,
  fade: true,
})
$('.slider-historic__slick').slick({
  slidesToShow: 1,
  dots: true,
  arrows: true,
  infinite: true,
  fade: false,
  prevArrow: $('.slider-historic__prev'),
  nextArrow: $('.slider-historic__next'),
  appendDots: $('.dots-custom__col'),
  adaptiveHeight: true,
  customPaging: function (slider, i) {
    // You can return any HTML structure you want here. This example uses a div for each dot.
    return '<div class="slick-custom__dots" id="dot' + i + '"></div>';
  }
})

$('.kismart-slider__content button').on('click', function () {
  $(this).closest('.kismart-slider__content').siblings('.kismart-slider__verso').addClass('active')
})
$('.kismart-slider__verso-button').on('click', function () {
  $(this).closest('.kismart-slider__verso').removeClass('active')
})

// Event listener for buttons
$('.kiproduct-variant__color-button.primary').on('click', function () {
  $('.kiproduct-variant__color-button.primary').removeClass('active')
  $(this).addClass('active')
  var color = $(this).data('color'); // Get the color from the data attribute of the clicked button
  var slideIndex = $('.ki-product__image__slider div[data-color="' + color + '"]').index(); // Find the index of the slide with the matching color
  $('.ki-product__image__slider').slick('slickGoTo', slideIndex); // Change to the slide with the specified index
});

$('.kiproduct-variant__color-button.secondary').on('click', function () {
  $('.sentence_variant').removeClass('active')
  $('.kiproduct-variant__color-button.secondary').removeClass('active')
  $(this).addClass('active')
  var color = $(this).data('color'); // Get the color from the data attribute of the clicked button
  var slideIndex = $('.ki-product__image__slider_second div[data-color="' + color + '"]').index(); // Find the index of the slide with the matching color

  $('.sentence_variant[data-color="' + color + '"]').addClass('active'); // Find the index of the slide with the matching color

  $('.ki-product__image__slider_second').slick('slickGoTo', slideIndex); // Change to the slide with the specified index
});


$('.section-slider__slick').slick({
  slidesToShow: 1.3,
  infinite: false,
  dots: true,
  arrows: false,
  autoplay: true,
  autoplaySpeed: 2000,
  appendDots: $('.dots-custom__container'),
  responsive: [
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    },
  ],
  customPaging: function (slider, i) {
    // You can return any HTML structure you want here. This example uses a div for each dot.
    return '<div class="slick-custom__dots" id="dot' + i + '"></div>';
  }
})
$('.kiproduct-description__slick').slick({
  slidesToShow: 1,
  infinite: true,
  dots: false,
  arrows: false,
  fade: false,
  autoplay: true,
  autoplaySpeed: 2000
})
$('.kiproduct-application__slick').slick({
  slidesToShow: 1,
  infinite: true,
  dots: false,
  arrows: false,
  fade: false,
  autoplay: true,
  autoplaySpeed: 2000
})


$('.reviews-slide').slick({
  slidesToShow: 2.4,
  infinite: false,
  dots: true,
  arrows: false,
  appendDots: $('.dots-custom__reviews'),
  responsive: [
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    },
  ],

  customPaging: function (slider, i) {
    // You can return any HTML structure you want here. This example uses a div for each dot.
    return '<div class="slick-custom__dots" id="dot' + i + '"></div>';
  }
})
$('.kismart-slider__inner').slick({
  slidesToShow: 1.4,
  infinite: false,
  dots: true,
  arrows: false,
  appendDots: $('.dots-custom__kismart'),
  responsive: [
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    },
  ],
  customPaging: function (slider, i) {
    // You can return any HTML structure you want here. This example uses a div for each dot.
    return '<div class="slick-custom__dots" id="dot' + i + '"></div>';
  }
})



$('#estimateForm__slick').slick({
  slidesToShow: 1,
  infinite: false,
  dots: true,
  arrows: false,
  adaptiveHeight: true,
  draggable: false,
  swipe: false,
  swipeToSlide: false,
  touchMove: false,
  draggable: false,
  accessibility: false,
  // prevArrow: $('.estimate-form__button .prev'),
  // nextArrow: $('.estimate-form__button .next'),
  appendDots: $('.dots-custom__container'),
  customPaging: function (slider, i) {
    // You can return any HTML structure you want here. This example uses a div for each dot.
    return '<div class="slick-custom__dots" id="dot' + i + 1 + '"></div>';
  }
})
// $('#estimateForm__slick').slick('resize');

$('.estimate-form__button .prev').on('click', function () {
  var currentSlide = $('#estimateForm__slick').slick('slickCurrentSlide');
  $('#estimateForm__slick').slick('slickPrev');
  $('.estimateForm__errors').removeClass('active')
  $('.estimateForm__errors p').text('')
  $('#estimateForm__slick').slick('resize');
})

$('.estimate-form__button .next').on('click', function () {
  $(this).css('pointer-events', 'none');
  var currentSlide = $('#estimateForm__slick').slick('slickCurrentSlide');
  var dataStep = $('.slick-slide[data-slick-index="' + currentSlide + '"]').attr('data-step');
  $('.estimateForm__errors').removeClass('active')
  $('.estimateForm__errors p').text('')

  /**
   * 
   * VERIFY THE DATAS
   * 
   */
  var formData = new FormData(document.getElementById("estimateForms"));
  formData.append('dataStep', dataStep);
  $('.error').remove();
  $('.estimateForm__errors-callback').removeClass('active')
  $('.estimateForm__errors-known').removeClass('active')
  $('.estimateForm__errors').removeClass('active')

  $.ajax({
    url: seize_rest + '/estimateForms',
    dataType: "json",
    data: formData,
    type: "POST",
    processData: false,
    contentType: false, //"application/json",
    cache: false,
    crossDomain: true,
    xhrFields: {
      withCredentials: true
    },
  })
    .done(function (response) {
      if (response.success) {
        if (dataStep == "step_callback") {
          $('#estimate-template').html(response.html)
        } else {
          if (formData.get('list_icon') == "Particulier") {
            $('.list-coordonnees li:first-child').hide()
            $('.list-coordonnees li:nth-child(2)').hide()
            $('#li-demander-demo').hide()
            $('label[for="kibolt-smart"]').addClass('inactive')
            $("#kibolt-smart").prop("checked", false);
          } else {
            $('.list-coordonnees li:first-child').show()
            $('.list-coordonnees li:nth-child(2)').show()
            $('#li-demander-demo').show()
            $('label[for="kibolt-smart"]').removeClass('inactive')
          }
          $('#estimateForm__slick').slick('slickNext');
          $('.estimate-form__button .next').css('pointer-events', 'all');
        }
      } else if (dataStep == "step_coordonnees") {

        $.each(response.errors, function (field, message) {
          // Append error message to the specific input field

          $('#' + field).after('<div class="error">' + message + '</div>');
        });
        $('#estimateForm__slick').slick('resize');
        $('.estimate-form__button .next').css('pointer-events', 'all');
      } else if (dataStep == "step_callback") {
        if (response.errors.list_callback) {
          $('.estimateForm__errors-callback').addClass('active')
          $('.estimateForm__errors-callback p').text(response.errors.list_callback)
        }
        if (response.errors.knowus) {
          $('.estimateForm__errors-known').addClass('active')
          $('.estimateForm__errors-known p').text(response.errors.knowus)
        }
        $('.estimate-form__button .next').css('pointer-events', 'all');
      } else {
        $('.estimateForm__errors').addClass('active')
        $('.estimateForm__errors p').text(response.errors)
        $('.estimate-form__button .next').css('pointer-events', 'all');
      }
      $('#estimateForm__slick').slick('resize');
      $('#estimateForm__slick').slick('setDimensions');
      $('#estimateForm__slick').slick('setPosition');
      $('.estimate-form__button .next').css('pointer-events', 'all');
    })

})

$('#step-row__callback-promo__valid').on('click', function (e) {
  let promo_code = $(this).siblings('#promo_code').val()
  $.ajax({
    url: seize_rest + '/promoCode',
    dataType: "json",
    data: { promo_code: promo_code },
    type: "POST",
    cache: false,
    crossDomain: true,
    xhrFields: {
      withCredentials: true
    },
    success: function (response) {
      $('.step-row__callback-promo__input').next('.error').remove();
      $('.step-row__callback-promo__input').next('.success').remove();
      if (response.success == true) {
        $('.step-row__callback-promo__input').after('<div class="success"><span>' + response.promo_code + '</span>: ' + response.promo_code_name + '</div>');
      } else {
        $('.step-row__callback-promo__input').after('<div class="error"><span>' + response.message + '</div>');
      }
    },
    error: function (xhr, status, error) {
      console.error(error);
    }
  });


})


$('.header-mobile__inner-menu__child').on('mouseenter', function () {
  let submenu = $(this).attr('data-menu')
  $('.sub-child__menu[data-menu="' + submenu + '"]').addClass('active')
})

$('.sub-child__close').on('click', function () {
  $('.sub-child__menu').removeClass('active')
})

$('.header-preheader__right button').on('click', function () {
  $('.header-preheader__right-links').toggleClass('active')
})
$('.header-preheader__right-close').on('click', function () {

  $('.header-preheader__right-links').removeClass('active')
})


$('#estimateForm__slick textarea').on('focus', function () {
  $(this).parent('label').siblings('input').prop('checked', true)
})



// gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);
gsap.registerPlugin(ScrollTrigger);


const totalHeight = $('.pin-spacer').height();
// console.log(totalHeight)
let sections = gsap.utils.toArray(".snap-item");
if (sections.length > 0) {
  let scrollTween = gsap.to(sections, {
    yPercent: -100 * (sections.length - 1),
    ease: "none", // <-- IMPORTANT!
    scrollTrigger: {
      trigger: ".kiproduct-pins",
      pin: true,
      scrub: 0.1,
      snap: {
        snapTo: 1 / (sections.length - 1), // Snap to the closest section
        duration: 0.5, // The duration of the snap animation
        ease: "power1.inOut" // Easing function for the snap animation
      },
      //snap: directionalSnap(1 / (sections.length - 1)),
      end: 3000,
      onToggle: (self) => {
        const dataY = $('.snap-item.active').attr("data-y");
        const dataX = $('.snap-item.active').attr("data-x");
        console.log(dataY + ' / ' + dataX)
        $('.moving-pin').attr('x', dataX)
        $('.moving-pin').attr('y', dataY)
      },
      onEnter: (self) => {
        const dataY = $('.snap-item.active').attr("data-y");
        const dataX = $('.snap-item.active').attr("data-x");
        console.log(dataY + ' / ' + dataX)
        $('.moving-pin').attr('x', dataX)
        $('.moving-pin').attr('y', dataY)
      },
      onUpdate: (self) => {
        // Calculate the index of the current section
        let index = Math.round(self.progress * (sections.length - 1));
        // Remove 'active' class from all sections
        sections.forEach(section => section.classList.remove('active'));
        // Add 'active' class to the currently visible section
        sections[index].classList.add('active');
      },
      start: "top top",
      markers: false
    }
  });
}
sections.forEach((section, index) => {
  gsap.to(section, {
    scrollTrigger: {
      trigger: section,
      markers: false,
      start: 'top top',
      end: 'bottom bottom',
      onEnter: (self) => {

        const dataY = $('.snap-item.active').attr("data-y");
        const dataX = $('.snap-item.active').attr("data-x");
        console.log(dataY + ' / ' + dataX)
        $('.moving-pin').attr('x', dataX)
        $('.moving-pin').attr('y', dataY)
        console.log($('.moving-pin').attr('x'))
        console.log($('.moving-pin').attr('y'))
      },
      onEnterBack: (self) => {
        console.log('Enter')
        const dataY = $('.snap-item.active').attr("data-y");
        const dataX = $('.snap-item.active').attr("data-x");
        console.log(dataY + ' / ' + dataX)
        $('.moving-pin').attr('x', dataX)
        $('.moving-pin').attr('y', dataY)


      },
      toggleClass: { targets: sections[index], className: "active" }
    }
  })
});


$(".accordion").click(function () {
  // Toggle between adding and removing the "active" class
  $(this).toggleClass("active");

  // Toggle between hiding and showing the active panel
  var panel = $(this).next();
  if (panel.css("display") === "block") {
    panel.css("display", "none");
  } else {
    panel.css("display", "block");
  }
});
$(".application-accordion").click(function () {
  // Toggle between adding and removing the "active" class
  $(this).toggleClass("active");

  // Toggle between hiding and showing the active panel
  var panel = $(this).next();
  if (panel.css("display") === "block") {
    panel.css("display", "none");
  } else {
    panel.css("display", "block");
  }
});


$('.back-to-top__button').on('click', function () {
  $("html, body").animate({ scrollTop: 0 }, "slow");
  return false;
})

$('.hamburger').on('click', function () {
  $(this).toggleClass('active')
  $('.header-principal__mobile').toggleClass('active')
})

$('.header-mobile__inner-menu__child-mobile').on('click', function (e) {
  e.preventDefault();
  let submenuMobile = $(this).attr('data-menu')
  $('.sub-child__menu-mobile[data-menu="' + submenuMobile + '"]').addClass('active')
})
$('.sub-child__close-mobile').on('click', function () {
  $('.sub-child__menu-mobile').removeClass('active')
})

$('.archive-informations__categories button').on('click', function () {
  $('.archive-informations__categories button').removeClass('active')
  $(this).addClass('active')
  let category = $(this).attr('data-cat')
  $.ajax({
    url: seize_rest + '/informations-conseils',
    dataType: "json",
    data: { category: category },
    type: "POST",
    cache: false,
    crossDomain: true,
    xhrFields: {
      withCredentials: true
    },
    success: function (response) {
      console.log(response);
      if (response.success == true) {
        $('.archive-informations__list').html(response.html)
      } else {

      }
    },
    error: function (xhr, status, error) {
      console.error(error);
    }
  });
})

/**
 * 
 * COMPLIANZ
 * 
 */

function getCookie(name) {
  var nameEQ = name + "=";
  var cookies = document.cookie.split(';');
  for (var i = 0; i < cookies.length; i++) {
    var cookie = cookies[i];
    while (cookie.charAt(0) == ' ') {
      cookie = cookie.substring(1, cookie.length);
    }
    if (cookie.indexOf(nameEQ) === 0) {
      return cookie.substring(nameEQ.length, cookie.length);
    }
  }
  return null;
}


let complianz = getCookie('cmplz_banner-status')
if (complianz == "show" || complianz == undefined) {
  $('#cmplz-cookiebanner-container').removeClass('inactive')
  $('#cmplz-cookiebanner-container').addClass('show')
} else {
  $('#cmplz-cookiebanner-container').addClass('inactive')
  $('#cmplz-cookiebanner-container').removeClass('show')
}
$(".cmplz-accept, .cmplz-deny, .cmplz-save-preferences").on("click", function () {
  $('#cmplz-cookiebanner-container').addClass('inactive')
  $('#cmplz-cookiebanner-container').removeClass('show')
});

$('.cmplz-btn.cmplz-manage-consent').on('click', function () {
  $('#cmplz-cookiebanner-container').removeClass('inactive')
  $('#cmplz-cookiebanner-container').addClass('show')
})

$('.page-template-template-tunnel-de-devis').on('keydown', function (e) {
  if (e.keyCode == 9) {

    e.preventDefault();
  }
});


document.querySelectorAll('.video-player__facade').forEach((btn) => {
    btn.addEventListener('click', () => {
        const iframe = document.createElement('iframe');
        iframe.src = `https://www.youtube-nocookie.com/embed/${btn.dataset.videoId}?autoplay=1&rel=0`;
        iframe.title = btn.dataset.videoTitle;
        iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
        iframe.allowFullscreen = true;
        iframe.className = 'video-player__iframe';

        btn.replaceWith(iframe);
        iframe.focus(); 
    });
});